import type { CompetencyState, EngagementNextAction } from '@/types/mentorEngagements';

export type WorkspaceTab = 'overview' | 'sessions' | 'documents';
export function nextActionTarget(action: EngagementNextAction): { tab: WorkspaceTab; modal?: 'add' | 'review' | 'priorities' | 'engagement'; sessionId?: number } {
  switch (action.key) {
    case 'add_first_session': return { tab: 'sessions', modal: 'add' };
    case 'review_draft_sof':
    case 'finalize_sof': return { tab: 'sessions', modal: 'review', sessionId: action.session_id };
    case 'set_priorities': return { tab: 'overview', modal: 'priorities' };
    case 'record_practice': return { tab: 'sessions', sessionId: action.session_id };
    case 'complete_rule_checks': return { tab: 'overview', modal: 'engagement' };
    default: return { tab: 'documents' };
  }
}
export function stateLabelKey(state: CompetencyState | 'verified' | 'not_observed'): string {
  return `mentorEngagements.workspace.states.${state}`;
}

/** PCC sends booleans, while ACC/MCC use rating labels. Never treat false as missing. */
export function ratingLabelKey(value: string | boolean | null): string {
  const rating = value === true ? 'observed' : value === false ? 'not_observed' : value;
  return rating && ['observed', 'not_observed', 'meets', 'below', 'exceeds', 'does_not_meet', 'not_applicable'].includes(rating)
    ? `mentorEngagements.workspace.ratings.${rating}` : 'mentorEngagements.review.unrated';
}
